/**
 * slideshow-page-loop.js
 *
 * Purpose:
 * Adds page-level looping to Ritual slideshow carousels.
 * When the final page is reached, clicking "next" scrolls
 * smoothly back to the start instead of disabling the arrow.
 *
 * Reason:
 * Matches behaviour of custom FIC product slider and improves UX.
 *
 * Scope:
 * Sitewide – applies to all slideshow-component instances.
 *
 * Added by: Lou / Hello Designs
 * Date: Feb 2026
 */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('slideshow-component').forEach(component => {
    const scroller = component.querySelector('slideshow-slides[ref="scroller"]');
    const nextBtn = component.querySelector('button[ref="next"]');

    if (!scroller || !nextBtn) return;

    const atEnd = () => {
      const tolerance = 2; // px fudge factor
      return (
        scroller.scrollLeft + scroller.clientWidth >=
        scroller.scrollWidth - tolerance
      );
    };

    nextBtn.addEventListener(
      'click',
      (e) => {
        if (atEnd()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          scroller.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        }
      },
      true // capture phase – beats Ritual’s handler
    );
  });
});